import { observer } from "mobx-react-lite";
import React, { FC, FormEvent, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Context } from "..";

const RestoreForm: FC = () => {
  const [email, setEmail] = useState<string>("");
  const { store } = useContext(Context);
  const navigate = useNavigate();

  const onSubmitHandler = async (evt: FormEvent) => {
    evt.preventDefault();
    const response = await store.restoreLink(email);
    if (response) {
      const formBlock = document.querySelector(".form__block");
      const formSubmit = document.querySelector(".form__submit");
      const formInputs = formBlock?.querySelectorAll(".form__input");
      formInputs?.forEach((input) => {
        input.classList.add("invalid");
      })
      const errorBlock = formBlock?.querySelector(".form__error");
      formBlock?.classList.add("shake");
      setTimeout(() => {
        formBlock?.classList.remove("shake");
      }, 500);
      if (errorBlock) {
        return;
      }
      const error = document.createElement("div");
      error.classList.add("form__error");
      error.textContent = response;
      formBlock?.insertBefore(error, formSubmit);
    } else {
      const formBlocks = document.querySelectorAll(".form__block");
      formBlocks.forEach((block) => {
        if (block.classList.contains('form__block--visible')) {
          block.classList.add("form__block--hidden");
          block.classList.remove("form__block--visible");
        } else {
          block.classList.remove("form__block--hidden");
          block.classList.add("form__block--visible");
        }
      })
      setTimeout(() => navigate("/"), 5000);
    }
  }


  return (
    <div className="form">
      <form className="form__block form__block--visible" onSubmit={onSubmitHandler} autoComplete="on">
        <fieldset className="form__field">
          <label className="form__label" htmlFor="form-email">Ваш email</label>
          <input
            className="form__input"
            onChange={(e) => {
              setEmail(e.target.value);
              if (e.target.value.trim() !== '') {
                e.target.parentElement?.classList.add("focus");
              } else {
                e.target.parentElement?.classList.remove("focus");
              }
              if (e.target.classList.contains('invalid')) {
                e.target.classList.remove("invalid");
              }
            }}
            inputMode="email"
            value={email}
            type="email"
            placeholder="Ваш email"
            id="form-email"
          />
        </fieldset>
        <button className="form__submit" type="submit">
          Відновити пароль
        </button>
      </form>
      <div className="form__block form__block--successful form__block--hidden">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50"><circle cx="25" cy="25" r="25" fill="#25ae88" /><path fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M38 15 22 33l-10-8" /></svg>
        <p className="form__text">Лист відправлений на пошту</p>
      </div>
    </div>
  );
};

export default observer(RestoreForm);
